import React from 'react'
import { IIcon } from './Icon.interface'
import { IconTestIds } from './iconTestIds'

export const GrowIcon = ({ classes }: IIcon) => (
  <svg
    data-testid={IconTestIds.Grow}
    className={classes}
    width="41"
    height="42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="41" height="42" rx="6" fill="#fff" />
    <path
      d="M32.313 17.625v-7.25a1.5 1.5 0 00-1.5-1.5h-6.188M8.688 24.813v7.25a1.5 1.5 0 001.5 1.5h6.187"
      stroke="#A0A0A0"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
)
